'use client';
import Footer from '@/features/home/footer/components/Footer';
import Header from '@/features/home/header/components/Header';
import '../style/sass/style.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import Link from 'next/link';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <>
      <Header />

      <div className="error padding-top padding-bottom sec-bg-color2">
        <div className="container">
          <div className="error__wrapper">
            <div
              className="error__inner"
              data-aos="fade-up"
              data-aos-duration={1000}
            >
              <div className="error__thumb text-center">
                <img src="/images/others/error.png" alt="404 image" />
              </div>
              <div className="error__content text-center">
                <h3>
                  Oops! <span>{error.message}</span>
                </h3>
                <Link
                  href="/"
                  onClick={() => reset()}
                  className="trk-btn trk-btn--border trk-btn--primary me-3"
                >
                  Try Again
                </Link>
                <Link
                  href="/"
                  className="trk-btn trk-btn--border trk-btn--primary"
                >
                  Back to home
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
